import { render } from "./admin-statistics.vue?vue&type=template&id=21b6501c&scoped=true"
import script from "./admin-statistics.vue?vue&type=script&lang=js"
export * from "./admin-statistics.vue?vue&type=script&lang=js"

import "./admin-statistics.vue?vue&type=style&index=0&id=21b6501c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b6501c"]])

export default __exports__